<template>
  <div id="index">
    <div class="sticky">
      <v-expand-transition>
        <v-card v-show="openSearchArea" flat>
          <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
              v-model="query_pref"
              :items="prefs"
              style="padding-top:0;"
              placeholder="都道府県で絞り込む"></v-select>
            </v-flex>
            <v-flex xs12>
              <v-text-field 
                v-model="query_kwd"
                placeholder="飲食店をキーワードで検索する"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-btn @click="onSearch" color="primary" block large><v-icon>search</v-icon>検索</v-btn>
            </v-flex>
          </v-layout>
          <v-btn v-if="openSearchArea" @click="openSearchArea=!openSearchArea" block flat class="blue-grey lighten-5"><v-icon>close</v-icon>検索エリアを閉じる</v-btn>
          </v-container>
        </v-card>
      </v-expand-transition>
      <v-flex 
         @click="openSearchArea=!openSearchArea"
        xs12 v-if="!openSearchArea" class="primary" style="text-align:right;">
        <v-btn outline round color="white">
          {{queryForDisplay | textTrim(20)}}<v-icon style="margin-left:10px;">search</v-icon>
        </v-btn>
      </v-flex>
    </div>
    <v-card flat v-if="isNotFound">
      <v-container>
        検索結果が0件です。
      </v-container>
    </v-card>
    <!-- 検索結果 -->
    <div style="min-height:200px;">
      <shop-card :shop=s v-for="(s, id) in shops" :key=id
        @onShopCardClick=onShopCardClick
      ></shop-card>
    </div>
    <!-- /検索結果 -->
    <div v-show="isLoading" style="text-align:center;margin:16px;">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <v-container v-show="!isLoading">
      <v-btn @click="onNext" large block color="primary">もっと見る</v-btn>
    </v-container>
  </div>
</template>

<script>
import ShopCard from '@/components/card/ShopCard.vue'
var queryForDisplayInit = '飲食店を検索'
export default {
  name: 'ShopSearch',
  data () {
    return {
      prefs: ['北海道' ,'青森県' ,'岩手県' ,'宮城県' ,'秋田県' ,'山形県' ,'福島県' ,'茨城県' ,'栃木県' ,'群馬県' ,'埼玉県' ,'千葉県' ,'東京都' ,'神奈川県' ,'新潟県' ,'富山県' ,'石川県' ,'福井県' ,'山梨県' ,'長野県' ,'岐阜県' ,'静岡県' ,'愛知県' ,'三重県' ,'滋賀県' ,'京都府' ,'大阪府' ,'兵庫県' ,'奈良県' ,'和歌山県' ,'鳥取県' ,'島根県' ,'岡山県' ,'広島県' ,'山口県' ,'徳島県' ,'香川県' ,'愛媛県' ,'高知県' ,'福岡県' ,'佐賀県' ,'長崎県' ,'熊本県' ,'大分県' ,'宮崎県' ,'鹿児島県' ,'沖縄県'],
      isLoading: false,
      openSearchArea: false,
      shops: [],
      isNotFound:false,
      breadsCrumbs: [{name: 'home', meta: {pageName: 'トップ'}}, {name: 'searchShops', meta: {pageName: '飲食店検索'}}]
    }
  },
  watch: {
    '$route' (to) {
      if (to.query !== undefined && to.query.s === '1') {
        this.init()
        this.setURL()
      }
    }
  },
  computed: {
    query_kwd: {
      get () {
        return this.$store.state.shops.query.kwd
      },
      set (kwd) {
        this.$store.commit('setShopsQueryKwd', kwd)
      }
    },
    query_pref: {
      get () {
        return this.$store.state.shops.query.pref
      },
      set (p) {
        this.$store.commit('setShopsQueryPref', p)
      }
    },
    queryForDisplay () {
      let text = ''
      if (this.query_kwd !== '') text = text + this.query_kwd + ' '
      if (this.query_pref !== '') {
        text = text + this.query_pref + ' '
      }
      if (text !== '') return text
      return queryForDisplayInit
    },
    headerTitle () {
      let text = '辛い飲食店検索'
      if (this.queryForDisplay !== queryForDisplayInit) {
        text = this.queryForDisplay + 'の' + text
      }
      return text
    }
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      // queryを元に検索パラメータを設定
      let query = this.$route.query
      if (query) {
        this.$store.commit('initShops')
      }
      if (query.kwd) {
        this.query_kwd = query.kwd
      }
      if (query.pref) {
        this.query_pref = query.pref
      }
      // 検索
      this.doSearch()
      this.$emit('updateHead')
    },
    onSearch () {
      this.setURL()
      this.doSearch()
      this.$emit('updateHead')
    },
    async doSearch () {
      this.isLoading = true
      this.openSearchArea = false
      window.scrollTo(0, 0)
      this.$store.commit('setShopsQuery')
      this.isNotFound = false
      this.shops = await this.$store.dispatch('getShopsByQuery', true)
      if (this.shops.length === 0) {
        this.isNotFound = true
      }
      this.isLoading = false
    },
    setURL () {
      let query = {}
      if (this.query_kwd !== '') {
        query.kwd = this.query_kwd
      }
      if (this.query_pref !== '') {
        query.pref = this.query_pref
      }
      this.$router.replace({name: 'searchShops', query: query})
    },
    onShopCardClick (shop) {
      this.$router.push({name: 'ShopDetail', params: {id: shop.id}})
    },
    async onNext () {
      this.isLoading = true
      this.shops = await this.$store.dispatch('getShopsNext')
      this.isLoading = false
    }
  },
  components: {
    ShopCard
  },
  head: {
    title () {
      return {
        inner: this.headerTitle,
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '辛い飲食店を検索しよう。'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height: 90vh;
    text-align:center;
  }
  /* ↓スクロールに応じて要素を固定↓ */
  .sticky {
    position: -webkit-sticky;
    position:sticky;
    top:0;
    z-index: 2;
  }
  .thead-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 3;
  }
  .th-sticky {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 2;
  }
  /* ↑スクロールに応じて要素を固定↑ */
</style>

<style>
.tags-input {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.tags-input input {
    flex: 1;
    background: transparent;
    border: none;
}

.tags-input input:focus {
    outline: none;
}

.tags-input input[type="text"] {
    color: #495057;
}

.tags-input-wrapper-default {
    padding: 10px;
    background: #fff;
    border: 1px solid transparent;
    border-radius: .25rem;
    border-color: #dbdbdb;
}

/* The tag badges & the remove icon */
.tags-input span {
    margin-right: 0.3rem;
}

.tags-input-remove {
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    overflow: hidden;
}

.tags-input-remove:before, .tags-input-remove:after {
    content: '';
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    background: #5dc282;
    
    height: 2px;
    margin-top: -1px;
}

.tags-input-remove:before {
    transform: rotate(45deg);
}
.tags-input-remove:after {
    transform: rotate(-45deg);
}

/* Tag badge styles */
.tags-input-badge {
    display: inline-block;
    margin-top: 5px;
    padding: 10px;
    font-size: 100%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
}

.tags-input-badge-pill {
    padding-right: 0.6em;
    padding-left: 0.6em;
    border-radius: 10rem;
}

.tags-input-badge-selected-default {
    color: #212529;
    background-color: #f0f1f2;
}

/* Typeahead - badges */
.typeahead-badges > span {
    cursor: pointer;
    margin-right: 0.3rem;
}

/* Typeahead - dropdown */
.typeahead-dropdown {
    list-style-type: none;
    padding: 0;
    margin: 0;
    position: absolute;
    width: 100%;
    z-index: 1000;
}

.typeahead-dropdown li {
    padding: .25rem 1rem;
    cursor: pointer;
}

/* Typeahead elements style/theme */
.tags-input-typeahead-item-default {
    color: #fff;
    background-color: #343a40;
}

.tags-input-typeahead-item-highlighted-default {
    color: #fff;
    background-color: #f44336;
}
</style>